const auction_adding = {
  select_date: "Select date",
  operation_time: "Operation time",
  select_time: "Select time",
  select_date_first: "Select a date first",
  price_per_km: "Price per kilometer",
  max_surcharges: "Maximum number of surcharges is 10",
  min_value: "Minimum value is",
  max_value: "Maximum value is",
  no_krs: "You cannot add an auction without CEIDG documents.",
  surcharge_error: "The surcharge title must have a maximum of 200 characters. The surcharge value must be less than 1,000,000,000.",
  distance: "Distance",
  license: "License required",
  flat_rate: "Flat rate",
  payment_deadline: "Payment deadline",
  pick_currency: "Select currency",
  address_not_specific: "This address is not specific enough. Please provide a more precise address.",
  doc_nr: "Order number",
  settings: "Auction settings",
  default: "Default payment deadline",
  threshold: "Minimum bid increment (optional)",
  default_threshold: "The default bid increment is 1",
  threshold_placeholder: "Enter bid increment",
  add: "Add auction",
  pick_start_point: "Select starting point",
  pick_end_point: "Select destination point",
  add_middle_point: "Add intermediate point",
  choose_middle_point: "Select intermediate point",
  load_error_1: "At least one cargo is required",
  load_error_2: "Fill in the type of freight.",
  load_error_3: "Cargo data is incorrect.",
  warehouse_address_error: "The provided address is not specific enough",
  dates_chronological: "Warning! The route dates are not set in chronological order. To add the auction, set the dates so they follow one another.",
  cargos_empty: "Warning! Cargo parts cannot be empty or zero.",
  ramps_empty: "Warning! You must fill in all required ramps.",
  start_missing: "All data in the starting point must be filled in.",
  middle_missing: "All data in intermediate points must be filled in.",
  end_missing: "All data in the destination point must be filled in.",
  operation_missing: "All points must have an operation added.",
  full_cargo_transport_info: "The transport includes the entire cargo – all items will be transported together",
  choose_address: "Select address",
  address_placeholder: "Enter address...",
  choose_address_required: "Select address",
  operation_date: "Operation date",
  choose_date_required: "Select date",
  cargo_operations: "Cargo operations",
  loading_all_cargo: "Loading entire cargo",
  unloading_all_cargo: "Unloading entire cargo",
  full_cargo_note: "All cargo items will be transported together",
  start_date_before_end: "The start date must be earlier than the unloading date",
};
export default auction_adding;
